var module = angular.module('octopusApp.projects');

module.directive('azureCloudServiceSelector', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      model: '=',
      projectId: '=',
      getAccountId: '=',
      lockedToBound: '=',
      type: '@'
    },
    templateUrl: 'areas/projects/actions/azure_cloud_service/azure_cloud_service_selector.html',
    controllerAs: 'vm',
    controller: function ($scope, $q, octopusRepository, busy, $timeout) {
      var vm = this;
      vm.model = $scope.model;
      vm.projectId = $scope.projectId;
      vm.isLoading = busy.create();
      var getAccountId = $scope.getAccountId;

      vm.selectedCloudService = null;
      vm.selectedStorageAccount = null;

      vm.reset = {
        cloudServiceName: vm.model.cloudServiceName,
        storageAccountName: vm.model.storageAccountName 
      };

      vm.changed = function changed() {
        vm.model.cloudServiceName = vm.selectedCloudService ? vm.selectedCloudService.Name : null;
        vm.model.storageAccountName = vm.selectedStorageAccount ? vm.selectedStorageAccount.Name : null;
      };

      $scope.$watch(getAccountId,
              function (accountId) {
                if (!accountId) {
                  vm.isLoading.promise($timeout(function(){
                    vm.cloudServices = [];
                    vm.storageAccounts = [];
                  }, 100));
                  return;
                } 
                
                vm.isLoading.promise(octopusRepository.Accounts.get(getAccountId())
                        .then(function (account) {

                          return $q.all([
                          octopusRepository.Accounts.getCloudServices(account)
                                  .then(function (services) {
                                    vm.cloudServices = services;

                                    if (vm.model.cloudServiceName) {
                                      vm.selectedCloudService = services.filter(function (service) {
                                        return vm.model.cloudServiceName === service.Name;
                                      })[0];
                                    }
                                  }),

                          octopusRepository.Accounts.getStorageAccounts(account)
                                  .then(function (storageAccounts) {
                                    vm.storageAccounts = storageAccounts;

                                    if (vm.model.storageAccountName) {
                                      vm.selectedStorageAccount = storageAccounts.filter(function (storage) {
                                        return vm.model.storageAccountName === storage.Name;
                                      })[0];
                                    }
                                  })]);
                        }));
              }
      );
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_cloud_service/azure_cloud_service_selector.js
// module id = 5752331126551603
// module chunks = 1